import React, { useEffect, useRef } from "react";
import { addBaseMap } from "../lib/mapBase";
import { addMapLock } from "../lib/mapLock";
import { createPortal } from "react-dom";

const esc = (v) => String(v ?? "").replace(/[&<>"]/g, (c) => ({ "&": "&amp;", "<": "&lt;", ">": "&gt;", '"': "&quot;" }[c]));

const split = (v) => String(v || "").split(/[,;/]+/).map((x) => x.trim()).filter(Boolean);
const row = (k, v) => v ? `<div style="display:flex;gap:8px;padding:5px 0;border-top:1px solid #eef2f7"><div style="width:86px;flex-shrink:0;font-size:10px;font-weight:700;color:#64748b;padding-top:1px">${k}</div><div style="flex:1;min-width:0;font-size:12px;color:#0f172a;word-break:break-word">${v}</div></div>` : "";
const lines = (arr, href) => arr.map((x) => `<div><a href="${href(x)}" style="color:#1d4ed8;text-decoration:none">${esc(x)}</a></div>`).join("");
const card = (a) => `<div style="font-family:inherit;width:330px;max-width:80vw">
  <div style="background:#1e3a8a;color:#fff;padding:10px 12px;font-weight:800;font-size:13px;line-height:1.3">${esc(a.ad)}</div>
  <div style="padding:4px 12px 10px">
    ${row("YETKİLİ", esc(a.yetkili))}
    ${row("GSM", lines(split(a.gsm), (x) => "tel:" + x.replace(/[^+\d]/g, "")))}
    ${row("S.TEL", lines(split(a.tel), (x) => "tel:" + x.replace(/[^+\d]/g, "")))}
    ${row("EMAİL", lines(split(a.email).map((x) => x.toLowerCase()), (x) => "mailto:" + x))}
    ${row("ADRES", esc(a.merkez_adres))}
    ${row("İLÇE / İL", esc([a.merkez_ilce, a.merkez_il].filter(Boolean).join(" / ")))}
    ${row("HİZMET İLLERİ", (a.iller || []).map((x) => `<span style="display:inline-block;margin:0 3px 3px 0;padding:1px 7px;border-radius:999px;background:#dbeafe;color:#1e40af;font-size:10px;font-weight:700">${esc(x)}</span>`).join(""))}
    ${row("NOTLAR", esc(a.notlar))}
  </div></div>`;

export const AllAmbarMap = ({ list, onClose }) => {
  const ref = useRef(null);
  useEffect(() => {
    const L = window.L; if (!L || !ref.current) return;
    const map = L.map(ref.current, { center: [39, 35], zoom: 6 });
    addMapLock(map, "ambar-all");
    addBaseMap(map, "ambarlar");
    const cnt = {};
    list.forEach((a) => (a.iller || []).forEach((il) => { cnt[il] = (cnt[il] || 0) + 1; }));
    const max = Math.max(1, ...Object.values(cnt));
    const col = (n) => (!n ? "#e2e8f0" : ["#bfdbfe", "#93c5fd", "#60a5fa", "#3b82f6", "#1d4ed8"][Math.min(4, Math.floor(((n - 1) / max) * 5))]);
    fetch("/tr-iller.json").then((r) => r.json()).then((g) => {
      if (!map._loaded) return;
      L.geoJSON(g, { style: (f) => { const n = cnt[String(f.properties.name).toLocaleUpperCase("tr-TR")] || 0; return { color: "#fff", weight: 1, fillColor: col(n), fillOpacity: n ? 0.5 : 0.2 }; },
        onEachFeature: (f, l) => { const il = String(f.properties.name).toLocaleUpperCase("tr-TR"); l.bindTooltip(`${il}: ${cnt[il] || 0} AMBAR HİZMET VERİYOR`, { sticky: true }); } }).addTo(map).bringToBack();
    }).catch(() => {});
    const pts = [];
    list.filter((a) => a.lat != null).forEach((a) => {
      const icon = L.divIcon({ className: "", iconSize: [20, 20], iconAnchor: [10, 10], html: `<div style="width:18px;height:18px;border-radius:50%;background:#ea580c;border:3px solid #fff;box-shadow:0 2px 6px rgba(0,0,0,.4)"></div>` });
      L.marker([a.lat, a.lng], { icon }).addTo(map).bindPopup(card(a), { className: "amb-pop", maxWidth: 360, minWidth: 280 }).bindTooltip(esc(a.ad));
      pts.push([a.lat, a.lng]);
    });
    if (pts.length) map.fitBounds(pts, { padding: [40, 40], maxZoom: 7 });
    const t = setTimeout(() => map.invalidateSize(), 300);
    return () => { clearTimeout(t); map.remove(); };
  }, [list]);
  const noLoc = list.filter((a) => a.lat == null).length;
  return createPortal(
    <div className="fixed inset-0 z-50 flex items-start justify-center overflow-auto bg-black/60 p-3 pt-10" onClick={onClose}>
      <div data-testid="all-ambar-map-dialog" className="w-full max-w-6xl space-y-2 rounded-xl border border-slate-700 bg-slate-900 p-3 text-slate-100" onClick={(e) => e.stopPropagation()}>
        <div className="flex items-center gap-2 text-sm font-bold">MWCRM AMBAR HARİTASI · {list.length} AMBAR
          <span className="text-[11px] font-normal text-slate-400"><b className="text-orange-500">●</b> AMBAR MERKEZİ (TIKLA: BİLGİLER) · MAVİ TON = O İLE HİZMET VEREN AMBAR SAYISI{noLoc ? ` · ${noLoc} AMBARIN İLİ GİRİLMEMİŞ` : ""}</span>
          <button data-testid="all-ambar-map-close" onClick={onClose} className="ml-auto rounded bg-slate-700 px-2 py-0.5 text-xs">KAPAT ×</button></div>
        <div ref={ref} data-testid="all-ambar-map" className="h-[70vh] w-full rounded-lg" />
      </div>
    </div>, document.body
  );
};
